import { useQuery } from '@tanstack/react-query';
import { fetchJobsDropdown } from '../api/jobsApi';

// Separate cache key from the paged ['jobs', filter] list so opening a split
// editor doesn't pollute or invalidate the table cache.
export default function useJobsDropdown() {
    return useQuery({
        queryKey: ['jobs', 'dropdown'],
        queryFn: fetchJobsDropdown,
    });
}
